/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostEvaluationPathParams = NonNullable<operations['postEvaluation']['parameters']['path']>;

export type PostEvaluationRequestBody = OperationRequestBodyContent<operations['postEvaluation']>;

export interface Input extends PostEvaluationPathParams {
  apiVersion?: string;
  body: PostEvaluationRequestBody;
}

export async function postEvaluation(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/evaluations', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
